import CARTS_FIELDS from "./carts.json";
import CHECKOUTS_FIELDS from "./checkouts.json";
import COLLECTIONS_FIELDS from "./collections.json";
import CUSTOMERS_FIELDS from "./customers.json";
import CUSTOMER_GROUPS_FIELDS from "./customer_groups.json";
import DISCOUNTS_FIELDS from "./discounts.json";
import DRAFT_ORDERS_FIELDS from "./draft_orders.json";
import FULFILLMENTS_FIELDS from "./fulfillments.json";
import FULFILLMENT_ORDERS_FIELDS from "./fulfillment_orders.json";
import INVENTORY_ITEMS_FIELDS from "./inventory_items.json";
import INVENTORY_LEVELS_FIELDS from "./inventory_levels.json";
import INVENTORY_SHIPMENTS_FIELDS from "./inventory_shipments.json";
import INVENTORY_TRANSFERS_FIELDS from "./inventory_transfers.json";
import LOCATIONS_FIELDS from "./locations.json";
import MARKETS_FIELDS from "./markets.json";
import ORDERS_FIELDS from "./orders.json";
import PRODUCTS_FIELDS from "./products.json";
import REFUNDS_FIELDS from "./refunds.json";
import SHOP_FIELDS from "./shop.json";
import TRANSACTIONS_FIELDS from "./transactions.json";
import THEMES_FIELDS from "./themes.json";

const SHOPIFY_FIELDS_MAP = {
  "Carts": CARTS_FIELDS,
  "Checkouts": CHECKOUTS_FIELDS,
  "Collections": COLLECTIONS_FIELDS,
  "Customers": CUSTOMERS_FIELDS,
  "Customer Groups": CUSTOMER_GROUPS_FIELDS,
  "Discounts": DISCOUNTS_FIELDS,
  "Draft Orders": DRAFT_ORDERS_FIELDS,
  "Fulfillments": FULFILLMENTS_FIELDS,
  "Fulfillment Orders": FULFILLMENT_ORDERS_FIELDS,
  "Inventory Items": INVENTORY_ITEMS_FIELDS,
  "Inventory Levels": INVENTORY_LEVELS_FIELDS,
  "Inventory Shipments": INVENTORY_SHIPMENTS_FIELDS,
  "Inventory Transfers": INVENTORY_TRANSFERS_FIELDS,
  "Locations": LOCATIONS_FIELDS,
  "Markets": MARKETS_FIELDS,
  "Orders": ORDERS_FIELDS,
  "Products": PRODUCTS_FIELDS,
  "Refunds": REFUNDS_FIELDS,
  "Shop": SHOP_FIELDS,
  "Transactions": TRANSACTIONS_FIELDS,
  "Themes": THEMES_FIELDS,
};

export default SHOPIFY_FIELDS_MAP;

export { CARTS_FIELDS };
export { CHECKOUTS_FIELDS };
export { COLLECTIONS_FIELDS };
export { CUSTOMERS_FIELDS };
export { CUSTOMER_GROUPS_FIELDS };
export { DISCOUNTS_FIELDS };
export { DRAFT_ORDERS_FIELDS };
export { FULFILLMENTS_FIELDS };
export { FULFILLMENT_ORDERS_FIELDS };
export { INVENTORY_ITEMS_FIELDS };
export { INVENTORY_LEVELS_FIELDS };
export { INVENTORY_SHIPMENTS_FIELDS };
export { INVENTORY_TRANSFERS_FIELDS };
export { LOCATIONS_FIELDS };
export { MARKETS_FIELDS };
export { ORDERS_FIELDS };
export { PRODUCTS_FIELDS };
export { REFUNDS_FIELDS };
export { SHOP_FIELDS };
export { TRANSACTIONS_FIELDS };
export { THEMES_FIELDS };
